export class PremadeMessage {
    constructor(
        public id: string,
        public name: string,
        public description: string,
        public title: string,
        public text: string,
        public user?: string,
        public date?: Date,
        public updateDate?: Date,
        public textDelta?: string,
    ) { }
}



// WEBPACK FOOTER //
// ./src/app/settings/premade-messages/shared/premade-message.model.ts